module.exports = __webpack_public_path__ + "img/heart_14.0ec95d19.png";